const stickyAddToCart = document.querySelector(".pdp-sticky-cart");
const sectionToWatch = document.getElementById("shopify-section-footer");

if (stickyAddToCart) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
        stickyAddToCart.classList.add("active");
    } else {
        stickyAddToCart.classList.remove("active");
    }
  });
  if (sectionToWatch) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            stickyAddToCart.classList.remove("active");
        } else {
            stickyAddToCart.classList.add("active");
        }
      });
    }, { threshold: 0.5 });
    observer.observe(sectionToWatch);
  }
}

$('#ReviewHeadingSlider').slick({
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,  
  arrows: false,
  infinite: true,
  autoplay: true,
  speed: 300
});


if (window.innerWidth <= 767 ) {  
  $('.howitworks-step-wrap').hide();   
  $('.howitworks-title-box').click(function(){  
  if ($('.howitworks-step-wrap').hasClass('active')) { 
    $('.howitworks-step-wrap').removeClass('active');
    $('.howitworks-step-wrap').slideUp('300');
  } else {  
    $('.howitworks-step-wrap').addClass('active');
    $('.howitworks-step-wrap').slideDown('300');
  } 
  }); 
} 

    // video play pause
    $('.video-wrapper #videoTrigger').click(function(){
      $(this).siblings('video').get(0).play();
      $(this).addClass('playing');
    });
      $('.video-wrapper video').click(function() {
      var video =  $(this).get(0),
          triggerBtn = $(this).siblings('#videoTrigger');
      if (video.paused ) {
        video.play();
        $(triggerBtn).addClass('playing');
      }else{
        video.pause();
        $(triggerBtn).removeClass('playing');
      }
    });
    
    $('.video-wrapper video').on('ended', function() {
      var video =  $(this).get(0),
          triggerBtn = $(this).siblings('#videoTrigger');
      $(triggerBtn).removeClass('playing');
    });


//mobile drawer
// $(document).ready(function() {
//     var lastClickedButton = null;

//     $(".mobile-nav__link--button").click(function() {
//         var currentButton = $(this);
        

//         if (currentButton.is(lastClickedButton)) {
            
//             $("#NavDrawer").removeClass("active");
//             lastClickedButton = null; 
//         } else {
           
//             $("#NavDrawer").addClass("active");
            
//             lastClickedButton = currentButton;
//         }
//     });
// });


$(document).ready(function() {
    $(".mobile-nav__link--button").click(function() {
        if($(".mobile-nav__link--button").hasClass('is-open'))
        {
          $("#NavDrawer").addClass("active");
        }
        else{
          $("#NavDrawer").removeClass("active");
        }
    });
});

// Klaviyo popup open 
document.getElementById('annoucement_btn_popup').addEventListener('click', function() {
    console.log('test');
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TsGtL5']);
});

// Image comparison slider
document.addEventListener('DOMContentLoaded', () => {
    const sliderContainer = $('.image-comparison-wrap'); 
    const imageSliderWraps = $('.image-slider-wrap');

    function initializeSlick() {
        const windowWidth = $(window).width();

        // Enable Slick only on mobile (≤ 768px) and if there are more than 2 slides
        if (windowWidth <= 768 && imageSliderWraps.length > 1) {
            if (!sliderContainer.hasClass('slick-initialized')) {
                sliderContainer.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    swipe: false,
                    draggable: false,
                    slidesToShow: 2,  // Adjust for better mobile experience
                    slidesToScroll: 1,
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 599,
                            settings: {
                                slidesToShow: 1.1,
                                arrows: true,
                                dots: false,
                            }
                        }
                    ]
                });
            }
        }
        else if (windowWidth > 768 && imageSliderWraps.length > 2) {
            if (!sliderContainer.hasClass('slick-initialized')) {
                sliderContainer.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    swipe: false,  // Disable swipe on desktop
                    draggable: false,  // Disable drag on desktop
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true  // Enable arrows on desktop
                });
            }
        } else {
            // Destroy Slick on desktop (> 768px) or if condition is not met
            if (sliderContainer.hasClass('slick-initialized')) {
                sliderContainer.slick('unslick');
            }
        }
    }

    // Run on page load
    initializeSlick();

    // Re-check on window resize
    $(window).on('resize', function () {
        initializeSlick();
    });
});
